/** Max files per investigation row — increase here if product limit changes */
export const MAX_INVESTIGATION_FILES = 5;

export const INVESTIGATION_FILE_FIELDS = [
  "MRI_FILE",
  "CT_SCAN_FILE",
  "X_RAYS_FILE",
  "EMG_NCV_FILE",
  "VASCULAR_STUDIES_FILE",
  "DEXA_SCAN_FILE",
  "MYELOGRAM_FILE",
  "DISCOGRAM_FILE",
  "PET_SCAN_FILE",
  "acupuncturist_FILE",
  "neurosurgeon_FILE",
  "chiropractor_FILE",
  "orthopedic_FILE",
  "rheumatologist_FILE",
  "internist_FILE",
  "physical_FILE",
  "neurologist_FILE",
  "psychiatrist_FILE",
];

export function normalizeInvestigationFiles(value) {
  if (value == null || value === "") return [];
  if (Array.isArray(value)) return value.filter((x) => x != null && x !== "");
  if (typeof File !== "undefined" && value instanceof File) return [value];
  if (typeof value === "string") return [value];
  return [];
}

export function normalizeInvestigationFieldFromApi(value) {
  return normalizeInvestigationFiles(value);
}

export function canAddInvestigationFiles(value) {
  return normalizeInvestigationFiles(value).length < MAX_INVESTIGATION_FILES;
}

export function getInvestigationFileCount(value) {
  return normalizeInvestigationFiles(value).length;
}

export function getInvestigationFileLabel(entry) {
  if (entry == null || entry === "") return "file";
  if (typeof File !== "undefined" && entry instanceof File) return entry.name;
  if (typeof entry === "string") {
    const tail = entry.split("?")[0].split("/").pop() || "";
    try {
      return tail ? decodeURIComponent(tail) : "Uploaded file";
    } catch {
      return tail || "Uploaded file";
    }
  }
  return "file";
}

export function appendInvestigationFiles(currentValue, incomingFileList) {
  const current = normalizeInvestigationFiles(currentValue);
  const room = MAX_INVESTIGATION_FILES - current.length;
  if (room <= 0) return current;
  const incoming = Array.from(incomingFileList || []).slice(0, room);
  return [...current, ...incoming];
}

export function removeInvestigationFileAt(currentValue, index) {
  const current = normalizeInvestigationFiles(currentValue);
  return current.filter((_, i) => i !== index);
}

export function investigationFileInputKey(fieldName, value) {
  const n = normalizeInvestigationFiles(value).length;
  return `${fieldName}-${n}`;
}

/** Upload column — buttons only; file names render in .investigation-file-list below the row */
export const INVESTIGATION_UPLOAD_COLUMN_BASE =
  "flex-1 px-3 py-4 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex flex-col justify-center min-w-0 border-2 border-l-0 rounded-e-full";

export const INVESTIGATION_UPLOAD_COLUMN_GRAY = `${INVESTIGATION_UPLOAD_COLUMN_BASE} bg-[#f0f0f0] border-[#d4d4d4]`;
export const INVESTIGATION_UPLOAD_COLUMN_WHITE = `${INVESTIGATION_UPLOAD_COLUMN_BASE} bg-white border-[#CDCDCD]`;

export const INVESTIGATION_ENTRY_CLASS = "investigation-entry w-full";
export const INVESTIGATION_FILE_LIST_CLASS = "investigation-file-list";
export const INVESTIGATION_FILE_CHIP_CLASS = "investigation-file-chip";
